import { Component, OnInit, Input, Host } from "@angular/core";
import { FormGroup, AbstractControl, Validators } from "@angular/forms";

import { FormToolsService, ColorValidator } from "@atenea-cms";

@Component({
  selector: "slide-action-form",
  templateUrl: "./slide-action-form.component.html",
  styleUrls: ["./slide-action-form.component.scss"],
})
export class SlideActionFormComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() productSheet?: boolean;

  types: Array<Object> = [
    { value: "change-media", label: "Cambiar imagen/video" },
    { value: "youtube", label: "Mostrar video de Yotube" },
    { value: "url", label: "Enviar a url" },
  ];

  styles: Array<Object> = [
    { value: "icon", label: "Icono" },
    { value: "color", label: "Color" },
    { value: "button", label: "Botón" },
    { value: "button-border-primary", label: "Botón con borde" },
    { value: "button-border-secondary", label: "Botón con border secundario" },
    { value: "button-video", label: "Botón video" },
  ];

  internalSections: Array<Object> = [
    { value: "product-header", label: "Cabecera" },
    { value: "summary", label: "Resumen" },
    { value: "awards", label: "Premios" },
    { value: "software", label: "Software" },
    { value: "hot-points", label: "Puntos Calientes" },
    { value: "specs", label: "Especificaciones" },
    { value: "downloads", label: "Descargas" },
    { value: "videos", label: "Videos" },
    { value: "sections", label: "Secciones" },
  ];

  constructor(public ft: FormToolsService) {}

  ngOnInit() {
    if (this.productSheet) {
      this.types.push({
        value: "anchor",
        label: "Mover a sección interna",
      });
    }

    this.checkChanges();
  }

  checkChanges(): void {
    const style: AbstractControl = this.form.get("style");

    style.valueChanges.subscribe(this.styleChange.bind(this));
    this.styleChange(style.value);
  }

  styleChange(type: string): void {
    const colorPrimary: AbstractControl = this.form.get("colorPrimary");
    const colorSecondary: AbstractControl = this.form.get("colorSecondary");
    const label: AbstractControl = this.form.get("label");

    colorPrimary.clearValidators();
    colorSecondary.clearValidators();
    label.clearValidators();

    switch (type) {
      case "color":
        colorPrimary.setValidators([Validators.required, ColorValidator]);

        colorSecondary.setValidators([ColorValidator]);

        break;

      case "button-primary":
      case "button-secondary":
        label.setValidators([Validators.required]);

        break;
    }

    colorPrimary.updateValueAndValidity();
    colorSecondary.updateValueAndValidity();
    label.updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/common/components/slide-action-form/slide-action-form.component.ts